export function getdata() {
	let obj = {
		headData: [{
				title: "姓名",
				prop: "userName",
				width: "100"
			},
			{
				title: "用户名",
				prop: "userName",
				width: "100"
			},
			{
				title: "手机",
				prop: "phone",
				width: "100"
			},
			{
				title: "邮箱",
				prop: "email",
				width: "100"
			}
		],
		
	}
	return obj
}
